// extracted by mini-css-extract-plugin
export var actionButton = "_qr-0";
export var actionMenuContainer = "_qr-i";
export var bubble = "_qr-2";
export var bubbleActionMenu = "_qr-j";
export var bubbleContext = "_qr-6";
export var bubbleItems = "_qr-7";
export var customer = "_qr-3";
export var divider = "_qr-8";
export var fileList = "_qr-9";
export var hiddenComment = "_qr-o";
export var infoAbove = "_qr-a";
export var internal = "_qr-4";
export var lightActionButton = "_qr-1";
export var link = "_qr-b";
export var merchant = "_qr-5";
export var message = "_qr-c";
export var profilePicture = "_qr-e";
export var quillToolbarContainer = "_qr-f";
export var senderDate = "_qr-g";
export var senderDateCustomer = "_qr-h";
export var senderName = "_qr-d";
export var time = "_qr-k";
export var uploadedImage = "_qr-l";
export var username = "_qr-m";
export var xsmall = "_qr-n";